// eslint-disable-next-line import/prefer-default-export
export const isMobileView = () => window.innerWidth <= 600;

export const scrollToView = () => {
    if (isMobileView()) {
        if (typeof document === 'object') {
            const lypForm = document.getElementById('ulx-step-indicator');
            setTimeout(() => {
                window.scrollTo({
                    behavior: 'smooth',
                    top:
                        lypForm.getBoundingClientRect().top
                        - document.body.getBoundingClientRect().top
                        - 65
                });
            }, 500);
        }
    } else {
        window.scrollTo(0, 0);
    }
};
